<template>
  <div>
    <crud-table
      create-route="campaigns.create"
      :columns="fields"
      vuex-prefix="campaigns"
      create-role="Developer"
      fetch-address="campaigns"
    >
      <template #cell(picAdd)="data">
        <img style="height: 40px" :src="data.item.picAdd" />
      </template>
      <template #cell(vidAdd)="data">
        <video
          style="width: 200px"
          v-if="data.item.vidAdd !== ''"
          controls
          :src="data.item.vidAdd"
        ></video>
      </template>
      <template #cell(tablighKindId)="data">
        {{
          data.item.tablighKindId !== null && data.item.campaign_kind !== null
            ? data.item.campaign_kind.name
            : '----'
        }}
      </template>
      <template #cell(isActive)="data">
        <span
          :class="{
            'text-success': data.item.isActive == 1,
            'text-danger': data.item.isActive == 0,
          }"
        >
          {{ data.item.isActive ? 'فعال' : 'غیرفعال' }}
        </span>
      </template>
      <template #cell(isTaeid)="data">
        <span
          :class="{
            'text-success': data.item.isTaeid == 1,
            'text-danger': data.item.isTaeid == 0 || data.item.isTaeid == null,
          }"
        >
          {{ data.item.isTaeid ? 'تایید شده' : 'تایید نشده' }}
        </span>
      </template>
      <template #cell(canSkip)="data">
        {{ data.item.canSkip ? 'دارد' : 'ندارد' }}
      </template>
      <template #cell(justMine)="data">
        {{ data.item.justMine ? 'بله' : 'خیر' }}
      </template>
      <template #cell(campaign_status_id)="data">
        <span
          :class="{
            'text-primary':
              data.item.campaign_status_id === 1 ||
              data.item.campaign_status_id === 2,
            'text-warning': data.item.campaign_status_id === 3,
            'text-danger': data.item.campaign_status_id === 4,
            'text-success': data.item.campaign_status_id === 5,
          }"
        >
          {{ data.item.campaign_status.name }}
        </span>
      </template>
      <template #cell(actions)="data">
        <table-action-buttons
          fa-title="کمپین"
          route="campaigns"
          :record-id="data.item.id"
          :delete-title="data.item.name"
          @deleted="data.itemDeleted(data.itemDeleted(data.item))"
        />
      </template>
    </crud-table>
  </div>
</template>

<script>
export default {
  computed: {
    fields() {
      return [
        {
          key: 'vidAdd',
          sortable: false,
          thStyle: { width: '250px' },
          label: 'ویدئو',
        },
        {
          key: 'name',
          sortable: true,
          label: 'نام کمپین',
          thStyle: { width: '180px' },
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'picAdd',
          sortable: false,
          label: 'آیکن',
          thStyle: { width: '80px' },
          thClass: 'd-none d-md-table-cell',
          tdClass: 'd-none d-md-table-cell',
        },
        {
          key: 'campaign_status_id',
          sortable: true,
          label: 'وضعیت',
          thStyle: { width: '200px' },
          filter: {
            component: 'SelectFilter',
            operator: '$in',
            value: [],
            items: this.statusOptions,
          },
        },
        {
          key: 'btnText',
          sortable: false,
          label: 'متن دکمه فرود',
          show: false,
          thStyle: { width: '180px' },
          filter: {
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'tablighKindId',
          sortable: true,
          label: 'نوع تبلیغ',
          show: false,
          thStyle: { width: '180px' },
          filter: {
            component: 'SelectFilter',
            operator: '$in',
            value: [],
            items: this.kindOptions,
          },
        },
        {
          key: 'canSkip',
          sortable: true,
          label: 'امکان رد کردن',
          show: false,
          thStyle: { width: '100px' },
          filter: {
            component: 'SwitchFilter',
            operator: '$eq',
            value: 0,
          },
        },
        {
          key: 'minAndroid',
          sortable: true,
          label: 'حداقل API اندروید',
          show: false,
          thStyle: { width: '100px' },
          filter: {
            component: 'NumberFilter',
            operator: '$gte',
            value: '',
          },
        },
        {
          key: 'maxAndroid',
          sortable: true,
          label: 'حداکثر API اندروید',
          show: false,
          thStyle: { width: '100px' },
          filter: {
            component: 'NumberFilter',
            operator: '$gte',
            value: '',
          },
        },
        {
          key: 'dailybudget',
          sortable: true,
          label: 'بودجه روزانه',
          formatPrice: true,
          show: false,
          thStyle: { width: '100px' },
          filter: {
            component: 'NumberFilter',
            operator: '$gte',
            value: '',
          },
        },
        {
          key: 'totalBudget',
          sortable: true,
          label: 'بودجه کل',
          thStyle: { width: '120px' },
          show: false,
          formatPrice: true,
          filter: {
            component: 'NumberFilter',
            operator: '$gte',
            value: '',
          },
        },
        {
          key: 'hazine',
          sortable: true,
          label: 'هزینه',
          thStyle: { width: '100px' },
          show: false,
          formatPrice: true,

          filter: {
            component: 'NumberFilter',
            operator: '$gte',
            value: '',
          },
        },
        {
          key: 'isActive',
          sortable: true,
          label: 'فعال بودن',
          thStyle: { width: '80px' },
          show: false,
          filter: {
            component: 'SwitchFilter',
            operator: '$eq',
            value: 1,
          },
        },
        {
          key: 'isTaeid',
          sortable: true,
          label: 'وضعیت تایید',
          thStyle: { width: '100px' },
          show: false,
          filter: {
            component: 'SwitchFilter',
            operator: '$eq',
            value: 1,
          },
        },
        {
          key: 'justMine',
          sortable: true,
          label: 'نمایش فقط برای من',
          thStyle: { width: '150px' },
          show: false,
          filter: {
            component: 'SwitchFilter',
            operator: '$eq',
            value: 0,
          },
        },
      ]
    },
  },
  data() {
    return {
      statusOptions: [],
      campaignKindOptions: [],
    }
  },
  methods: {
    fetchMetaData() {
      this.$axios.get(`campaigns/meta-data`).then((res) => {
        this.statusOptions = res.data.campaign_statuses.map((item) => {
          return {
            text: item.name,
            value: item.id,
          }
        })

        this.kindOptions = res.data.kinds.map((item) => {
          return {
            text: item.name,
            value: item.id,
          }
        })
      })
    },
  },
  created() {
    this.fetchMetaData()
  },
}
</script>
